import React from 'react';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import BackgroundImage from '../../components/BackgroundImage';
import Linkify from '../../components/text/Linkify';

const Message = (props) => {
    const {
        id,
        type,
        className,
        playerProfileImages,
        name,
        message,
        timestamp,
        handleClick,
        hasNewMessage,
        isPreview,
        showBlockedIcon,
        profileLink,
        'data-testid': dataTestId,
    } = props;

    const onClick = () => {
        if (handleClick) {
            handleClick(id);
        }
    };

    const today = moment().startOf('day');
    const last7days = today.clone().subtract(7, 'days').startOf('day');

    function isToday(momentDate) {
        return momentDate.isSame(today, 'day');
    }
    function isWithinAWeek(momentDate) {
        return momentDate.isAfter(last7days);
    }
    function isThisYear(momentDate) {
        return moment(momentDate).isSame(new Date(), 'year');
    }

    const time = () => {
        if (isToday(moment.utc(timestamp).local())) {
            return moment.utc(timestamp).local().format('h:mma');
        }
        if (isWithinAWeek(moment.utc(timestamp).local())) {
            return moment.utc(timestamp).local().format('ddd, h:mma');
        }
        if (isThisYear(moment.utc(timestamp).local())) {
            return moment.utc(timestamp).local().format(isPreview ? 'MMM DD' : 'MMM DD, h:mma');
        }
        return moment.utc(timestamp).local().format(isPreview ? 'MM/DD/YYYY' : 'MM/DD/YYYY, h:mma');
    };

    const timeFull = moment.utc(timestamp).local().format('MM/DD/YYYY h:mma');

    return (
        <div className={`${type} ${className}`} onClick={onClick} data-testid={dataTestId}>
            <div className="avatar">
                <BackgroundImage
                    baseUrl={'/v1/player/'}
                    defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                    images={playerProfileImages}
                    imageType={'thumbnail'}
                    extraCls={'playerThumbnailImage'}
                />
            </div>
            <div className="content">
                <div className="name-wrapper d-flex">
                    <div className="name show-ellipsis" data-testid={dataTestId ? `${dataTestId}.name` : undefined}>
                        {profileLink ? (
                            <Link to={profileLink} onClick={(e) => e.stopPropagation()}>
                                {name}
                            </Link>
                        ) : (
                            name
                        )}
                    </div>
                    <div className="d-flex aic">
                        <div className="time" title={timeFull} data-testid={dataTestId ? `${dataTestId}.time` : undefined}>{time()}</div>
                        {showBlockedIcon && (
                            <div className="text-error pl4" title={`Contains blocked user(s)`} data-testid={dataTestId ? `${dataTestId}.blocked-icon` : undefined}>
                                <i className="utr utr-close-circle" />
                            </div>
                        )}
                    </div>
                </div>
                <div className={`preview ${hasNewMessage ? 'text-bold text-dark' : ''}`} data-testid={dataTestId ? `${dataTestId}.preview` : undefined}>
                    <Linkify>{message}</Linkify>
                </div>
            </div>
        </div>
    );
};

export default Message;
